import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

interface ReplayImportTaskParams {
  importId: string;
  taskId: string;
}

export default function useReplayImportTask(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "post",
    "/shops/{shopId}/imports/{importId}/tasks/{taskId}/replay",
    {
      invalidate: invalidateShop,
      useWorkerClient: true,
      mapVariables: ({ importId, taskId }: ReplayImportTaskParams) => ({
        params: { path: { shopId: shop.id, importId, taskId } },
      }),
    },
  );
}
